/* === Seashell: PDP assurance rows === */
(function(){
  var tpl = (window.SeashellCfg||{}).tpl||'';
  var INCLUDE = ['2026-22l-drybag','2026-changing-mat','2026-all-other-products','other-products','flask-template'];
  if(INCLUDE.indexOf(tpl)===-1) return;
  var country = (window.SeashellCfg||{}).country||'GB';
  var M=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  function fmt(d){return d.getDate()+' '+M[d.getMonth()];}
  function range(){var d=new Date(),c=0,e,l;for(var i=1;i<=20;i++){d.setDate(d.getDate()+1);if(d.getDay()!==0){c++;if(c===2)e=new Date(d);if(c===3){l=new Date(d);break;}}}return [e,l];}
  function ico(p){return '<span class="ssa-ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">'+p+'</svg></span>';}
  function build(){
    var truck='<path d="M1.5 5h12v9h-12z"/><path d="M13.5 8h4l3 3v3h-7z"/><circle cx="6" cy="16.5" r="1.7"/><circle cx="16.5" cy="16.5" r="1.7"/>';
    var badge='<circle cx="12" cy="8.5" r="5.5"/><path d="M8.5 13l-1.3 8 4.8-2.7 4.8 2.7-1.3-8"/><path d="M9.3 8.5l1.8 1.8 3.6-3.6"/>';
    var deliveryText;
    if(country==='GB'){ var r=range(); deliveryText='Estimated delivery '+fmt(r[0])+' to '+fmt(r[1]); }
    else { deliveryText='International delivery 7–10 working days'; }
    var w=document.createElement('div'); w.className='ss-assurance';
    w.innerHTML='<div class="ssa-row">'+ico(truck)+'<span class="ssa-txt">'+deliveryText+'<a class="ssa-link" href="/policies/shipping-policy">Read more</a></span></div>'+
                '<div class="ssa-row">'+ico(badge)+'<span class="ssa-txt">3 Year Performance Guarantee</span></div>';
    return w;
  }
  function go(){
    var info=document.querySelector('.product__info'); if(!info) return;
    try{ info.querySelectorAll('.product__text:has(svg.icon-check_mark)').forEach(function(b){b.style.display='none';}); }catch(e){}
    if(info.querySelector('.ss-assurance')) return;
    var anchor=info.querySelector('product-form, form[action*="/cart/add"], .product-form');
    var node=build();
    if(anchor && anchor.parentNode){ anchor.parentNode.insertBefore(node, anchor); } else { info.appendChild(node); }
  }
  if(document.readyState!=='loading') go(); else document.addEventListener('DOMContentLoaded', go);
})();

/* === Seashell: female/male model toggle === */
        (function(){
          function genderOf(el){
            var img=el&&el.querySelector?el.querySelector('img'):null;
            var alt=((img&&img.getAttribute('alt'))||'').toLowerCase();
            if(/\bfemale\b/.test(alt))return 'female';
            if(/\bmale\b/.test(alt))return 'male';
            return 'both';
          }
          function firstVisibleSlide(gallery,gender){
            var slides=gallery.querySelectorAll('.product__media-list .product__media');
            for(var i=0;i<slides.length;i++){
              var s=slides[i];
              if(getComputedStyle(s).display==='none')continue;
              var g=genderOf(s);
              if(g==='both'||g===gender)return s;
            }
            return null;
          }
          function init(toggle){
            if(toggle.dataset.wired)return; toggle.dataset.wired='1';
            var sec=toggle.getAttribute('data-section'), pid=toggle.getAttribute('data-product');
            var gallery=document.getElementById('ProductGallery-'+sec+'-'+pid);
            if(!gallery){toggle.style.display='none';return;}
            var preview=gallery.querySelector('.product__preview .product__media');
            var origHTML=preview?preview.innerHTML:null, origId=preview?preview.getAttribute('data-media-id'):null, origGender=preview?genderOf(preview):'both';
            var current='female';
            function apply(gender){
              current=gender;
              gallery.querySelectorAll('.product__media-list .product__media, .product__thumbnail').forEach(function(it){
                var g=genderOf(it);
                var show=(g==='both'||g===gender);
                it.hidden=!show;
                it.style.display=show?'':'none';
              });
              if(preview){
                if(origGender==='both'||origGender===gender){
                  if(preview.getAttribute('data-media-id')!==origId){preview.innerHTML=origHTML;preview.setAttribute('data-media-id',origId);}
                }else{
                  var fv=firstVisibleSlide(gallery,gender);
                  if(fv && fv.getAttribute('data-media-id')!==preview.getAttribute('data-media-id')){
                    preview.innerHTML=fv.innerHTML;
                    preview.setAttribute('data-media-id',fv.getAttribute('data-media-id'));
                    var pi=preview.querySelector('img'); if(pi){pi.loading='eager';pi.setAttribute('loading','eager');}
                  }
                }
                preview.hidden=false; preview.style.display='';
                /* Seashell: avoid showing the preview image twice — hide its twin in the media list, but ONLY while .product__preview is actually rendered (offsetParent!==null). On mobile the preview is hidden and the list IS the swipe slider, so hiding a slide would skip the main image. With the even-grid desktop layout the preview is also hidden, so this correctly skips and every gender-matching image shows in the grid. */
                if(preview.offsetParent!==null){
                  var pvId2=preview.getAttribute('data-media-id');
                  gallery.querySelectorAll('.product__media-list .product__media').forEach(function(s){
                    if(pvId2 && s.getAttribute('data-media-id')===pvId2){ s.hidden=true; s.style.display='none'; }
                  });
                }
              }
              var list=gallery.querySelector('.product__media-list'); if(list){try{list.scrollTo({left:0});}catch(e){list.scrollLeft=0;}}
              var sl=gallery.querySelector('slider-element'); if(sl){try{(sl.reset||sl.update||function(){}).call(sl);}catch(e){}}
              var dots=gallery.querySelector('media-dots'); if(dots&&dots.resetIndexes){try{dots.resetIndexes();}catch(e){}}
              var smd=document.querySelector('.seashell-model-details'); if(smd){var mf=smd.querySelector('.smd-female'), mm=smd.querySelector('.smd-male'); if(gender==='male'&&mm){if(mf)mf.style.display='none'; mm.style.display='';} else {if(mm)mm.style.display='none'; if(mf)mf.style.display='';}}
              toggle.querySelectorAll('button').forEach(function(b){var on=b.getAttribute('data-gender')===gender;b.classList.toggle('is-active',on);b.setAttribute('aria-pressed',on?'true':'false');});
              try{window.dispatchEvent(new Event('resize'));}catch(e){}
            }
            toggle.querySelectorAll('button').forEach(function(b){b.addEventListener('click',function(){apply(b.getAttribute('data-gender'));});});
            var picker=document.getElementById('VariantPicker-'+sec+'-'+pid);
            if(picker){picker.addEventListener('change',function(){setTimeout(function(){apply(current);},60);});}
            apply('female');
          }
          function boot(){document.querySelectorAll('.seashell-model-toggle').forEach(init);}
          if(document.readyState!=='loading')boot();else document.addEventListener('DOMContentLoaded',boot);
        })();

/* === Seashell: size guide cm/inch + modal wiring === */
                        (function(){
                          document.querySelectorAll('.seashell-sizeguide').forEach(function(sg){
                            if(sg.dataset.wired)return; sg.dataset.wired='1';
                            var cells=[];
                            sg.querySelectorAll('table td, table th').forEach(function(c){
                              var t=(c.textContent||'').trim();
                              if(/cm/i.test(t) && /\d/.test(t)){
                                c.setAttribute('data-cm-text', t);
                                c.setAttribute('data-in-text', t.replace(/(\d+(?:\.\d+)?)/g,function(m){return Math.round(parseFloat(m)/2.54);}).replace(/cm/ig,'in'));
                                cells.push(c);
                              }
                            });
                            var toggle=sg.querySelector('.sg-toggle');
                            if(!cells.length){return;}
                            if(toggle){toggle.removeAttribute('hidden');}
                            var cmTable=cells[0].closest('table');
                            if(toggle&&cmTable&&cmTable.parentNode){cmTable.parentNode.insertBefore(toggle,cmTable);}
                            var btns=sg.querySelectorAll('.sg-toggle button');
                            function setUnit(u){
                              cells.forEach(function(c){c.textContent=(u==='in')?c.getAttribute('data-in-text'):c.getAttribute('data-cm-text');});
                              btns.forEach(function(b){b.classList.toggle('is-active',b.getAttribute('data-unit')===u);});
                            }
                            btns.forEach(function(b){b.addEventListener('click',function(){setUnit(b.getAttribute('data-unit'));});});
                          });
                        })();

/* === Seashell: friendly discount-code errors (cart drawer) === */
(function(){
  var HINTS = {
    'SOCKS': 'First-time customers only – One per customer – £50 minimum spend – Add your pair to cart first',
    'FREECAP': 'The free cap offer has ended – every changing robe now comes with a free merino beanie & headband instead'
  };
  var ALIAS = { 'SOX':'SOCKS', 'SOCS':'SOCKS', 'SOCK':'SOCKS', 'SOCKS15':'SOCKS', 'FREE CAP':'FREECAP', 'CAPFREE':'FREECAP', 'FREECAPS':'FREECAP', 'CAP':'FREECAP' };
  document.addEventListener('input', function(e){
    var t = e.target;
    if(t && t.name === 'discount'){
      var f = t.closest('form[is="cart-discount"]');
      if(f) f.dataset.ssLastCode = (t.value || '').trim().toUpperCase();
    }
  }, true);
  if(!window.customElements || !customElements.whenDefined) return;
  customElements.whenDefined('cart-discount').then(function(){
    var CD = customElements.get('cart-discount');
    if(!CD || !CD.prototype || CD.prototype.ssHintPatched) return;
    CD.prototype.ssHintPatched = true;
    var orig = CD.prototype.setDiscountError;
    CD.prototype.setDiscountError = function(error){
      var canonical = null, typed = null;
      if(error && error.length){
        typed = (this.dataset.ssLastCode || '').toUpperCase();
        if(Object.prototype.hasOwnProperty.call(HINTS, typed)){ canonical = typed; error = HINTS[typed]; }
        else if(Object.prototype.hasOwnProperty.call(ALIAS, typed)){ canonical = ALIAS[typed]; error = 'The code is ' + canonical + ' – ' + HINTS[canonical]; }
      }
      /* 6 Oct 2026: FREECAP retired (Calum) — no cap auto-add, just the hint above */
      return orig.call(this, error);
    };
  });
})();

/* === Seashell: robe-order auto-pilot — the Robe Kit codes ===
   (25 Aug 2026 origin. Cap auto-add removed same day per Calum — FREECAP stays a typed
   code. 10 Sep 2026: PINK GIFT AUTO-ADD REMOVED — see below.)

   10 Sep 2026 — ONE ROBE UNLOCKS EVERYTHING, SECOND ROBE INCLUDED.
   The dearest robe is full price; every other unit in the basket is 25% off — accessories,
   clothing, a second towelling robe, a second changing robe. Shopify cannot say that in one
   discount (a BXGY "get 50" needs 50 items in the cart — tested, fails), so four hidden
   codes share the job and this block applies the right set:
     ROBE.BUNDLE    Basic 25% off 'Bundle Accessories' (towelling robes included).
                    Applied when a CHANGING robe + any paid entitled item are in the cart.
     ROBE.SECOND    BXGY: buy 1 changing robe, get 1 changing robe 25% off (pairs — 3 robes
                    = 1 discounted). Applied when 2+ changing-robe units are in the cart.
     TOWEL.BUNDLE   Basic 25% off 'Bundle Accessories — no towelling'. Applied when a
                    TOWELLING robe is the only robe type and a paid accessory is present.
     TOWEL.SECOND   BXGY: buy 1 towelling, get 1 towelling 25% off. Applied when 2+
                    towelling units and NO changing robe (a changing robe already takes 25%
                    off every towelling via ROBE.BUNDLE — stacking would give 44%).
   Shopify discounts the cheaper unit of a pair, so the dearest robe always stays full price.
   Verified on the preview 10 Sep 2026: chg+beanie £176.50; tow×2+beanie £121.50; chg+tow
   £205; chg×2+beanie £296.50; chg+tow×2+beanie £266.50; Black+Midnight £234.25.
   PINK GIFT: the automatic 'Pebble Pink — Free Beanie & Headband' BXGY and ROBE.SECOND
   both need the pink robe as their prerequisite; Shopify lets one item power only one
   BXGY, so with two pinks the gifts stopped being free and with pink+black ROBE.SECOND
   died. The gift pair is therefore retired with this release (deactivate the automatic
   discount AFTER publishing this theme — the old theme still auto-adds the gifts).
   Retired codes (BUNDLE25, and the gift auto-add) are stripped if a browser still carries
   them. Any code that is not ours (FREECAP…) is preserved verbatim.
   15 Sep 2026 — PINK GIFT AUTO-ADD RESTORED (Calum). A Pebble Pink robe in the cart adds
   Beanie Pink + Headband Pink once; the automatic BXGY 'Pebble Pink Set — free beanie +
   headband' (2284191449466) zeroes them. If the customer removes a gift it is not re-added
   while the robe stays in the cart (sessionStorage ssPinkSkip<variant>); if the pink robe
   leaves, gifts we added are removed and the skip flags cleared, so a size swap re-gifts. To avoid the one-item-one-BXGY clash, ROBE.SECOND is
   NOT applied while a pink robe is in the cart — the £40 gift pair stands in for the
   second-robe 25%.
   22 Sep 2026 — SECOND-ROBE DISCOUNTS REMOVED (Calum). The offer is one sentence again:
   buy a robe, accessories are 25% off. A second changing robe is never discounted; a
   second towelling robe is discounted only when a changing robe is in the cart (via
   ROBE.BUNDLE, which entitles towelling). ROBE.SECOND / TOWEL.SECOND are no longer
   applied here and are to be DEACTIVATED in Shopify after this theme is published; they
   stay in CODES so a browser still carrying one gets it stripped. The pink-robe exception
   below is therefore moot. Since 10 Sep the two codes had touched 6 of 83 orders.
   22 Sep 2026, later — PINK GIFTS MADE INDEPENDENT (Calum). The automatic BXGY
   'Pebble Pink Set' (2284191449466) zeroed the beanie + headband only as a PAIR (get-
   quantity 2): remove one and the other snapped back to full price (verified: £22). The
   old fix removed the other gift in the background, and that background /cart/change
   raced the customer's next click in the drawer — the stale line 404s ("no valid id or
   line parameter"), the theme alerts and bounces to /cart. Replaced by hidden code
   PINK.GIFT.7Q2K (2286042710394): Basic £40 off across Beanie Pink + Headband Pink,
   applied once per order, so each gift is free on its own. Applied here when a pink robe
   is in the cart, stripped when it leaves; gifts still auto-add once when the robe lands,
   a removed gift is NOT re-added this session, and nothing else is ever removed behind
   the customer's back. Deactivate the automatic BXGY once this theme is live.
   === */
(function(){
  var CHANGING  = [7921989517548,8161692123372,8659850297580,8659850166508,8249444204780];
  var TOWELLING = [7646192730348,8161713684716,8161714077932];
  var ACC_PIDS = [7446870819052,7481591595244,7645154738412,7646192730348,8161713684716,8161714077932,8161740685548,8161757233388,8571883127020,8571886338284,8622395982060,8622396145900,8622398931180,15313561813370,15313622663546,15918221230458,15936428343674,15936428376442,15936428409210,15936520651130,15936520716666];
  var CODE_CHG = 'ROBE.BUNDLE', CODE_CHG2 = 'ROBE.SECOND';
  var CODE_TOW = 'TOWEL.BUNDLE', CODE_TOW2 = 'TOWEL.SECOND';
  /* 6 Oct 2026 (later) — ONE gift set for EVERY changing robe (Calum): a free merino beanie + headband
     with any changing robe, colour-matched where stock allows and falling back to the next colour in
     stock, so the gift never goes missing while the Q4 merino stock clears. Funded by TWO hidden codes:
       ROBE.GIFT.BEANIE.3T   — BXGY: buy 1 changing robe, get 1 beanie (any of the four) at 100%, once per order.
                               Exactly one beanie free; a second beanie is a normal £25 line.
       ROBE.GIFT.HEADBAND.7P — Basic £20 across the four headbands. One headband free; a second headband
                               splits the £20 (£10 + £10 — same money as free + £20; the drawer displays it that way).
     Only ONE BXGY can be powered by the robe (tested 6 Oct: a second robe-powered BXGY never applies, with a
     quantity or a spend prerequisite; a 2-of-8 BXGY frees the two cheapest and needs both present; a free
     beanie cannot be the "buy" item for a headband BXGY) — hence the mixed pair. Exposure capped at £45/order.
     Supersedes the per-colour codes / automatic BXGYs
     (PINK.GIFT.7Q2K, MIDNIGHT.GIFT.4K7P, CAMO.GIFT.9R2M, "<Colour> Set" automatics) — retire those once
     this theme is live; until then this script strips the old codes from any cart it sees.
     Stock is checked live via /products/<handle>.js (cached 5 min in sessionStorage).
     Preference order per robe (beanie and headband picked independently):
       Black → black, white, sand, pink · Sand → sand, white, black, pink · Pink → pink, white, sand, black
       Midnight → white, black, sand, pink · Camo → sand, black, white, pink */
  var CODE_GIFT_B = 'ROBE.GIFT.BEANIE.3T', CODE_GIFT_H = 'ROBE.GIFT.HEADBAND.7P';
  var CODE_GIFT_H2 = 'ROBE.GIFT.HEADBAND2.7P', CODE_GIFT_H3 = 'ROBE.GIFT.HEADBAND3.7P';
  var OLD_GIFT_CODES = ['PINK.GIFT.7Q2K', 'MIDNIGHT.GIFT.4K7P', 'CAMO.GIFT.9R2M', 'ROBE.GIFT.5W8N', 'ROBE.GIFT.BEANIE.7P'];
  var GIFT_ORDER = {
    7921989517548: ['black','white','sand','pink'],
    8161692123372: ['sand','white','black','pink'],
    8659850297580: ['pink','white','sand','black'],
    8659850166508: ['white','black','sand','pink'],
    8249444204780: ['sand','black','white','pink']
  };
  var GIFT_KINDS = {
    beanie:   { black:{h:'merino-wool-beanie',v:42053622333676}, white:{h:'merino-wool-beanie-off-white',v:44394703880428}, sand:{h:'merino-wool-beanie-sand',v:56755281494394}, pink:{h:'merino-wool-beanie-pink',v:56755282280826} },
    headband: { black:{h:'headband-black',v:56755069616506}, white:{h:'headband-white',v:56755069583738}, sand:{h:'headband',v:56745230467450}, pink:{h:'headband-pink',v:56755069649274} }
  };
  var KIND_NAMES = Object.keys(GIFT_KINDS);
  var ALL_GIFT_VARS = [];
  KIND_NAMES.forEach(function(k){ Object.keys(GIFT_KINDS[k]).forEach(function(c){ ALL_GIFT_VARS.push(GIFT_KINDS[k][c].v); }); });
  var CODES = [CODE_CHG, CODE_CHG2, CODE_TOW, CODE_TOW2, 'BUNDLE25', CODE_GIFT_B, CODE_GIFT_H, CODE_GIFT_H2, CODE_GIFT_H3].concat(OLD_GIFT_CODES);
  var busy = false;
  function ss(k, v){ try{ if(v === undefined) return sessionStorage.getItem(k); if(v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); }catch(e){ return null; } }
  function kindOf(v){ var k = null; KIND_NAMES.forEach(function(kind){ Object.keys(GIFT_KINDS[kind]).forEach(function(c){ if(GIFT_KINDS[kind][c].v === v) k = kind; }); }); return k; }
  /* is this product in stock right now? (product-level 'available' from the storefront .js endpoint) */
  function avail(handle){
    var k = 'ssAv:' + handle, now = Date.now();
    try{ var c = JSON.parse(ss(k) || 'null'); if(c && now - c.t < 300000) return Promise.resolve(!!c.a); }catch(e){}
    return fetch('/products/' + handle + '.js', {credentials:'same-origin'}).then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p){ var a = !!(p && p.available); ss(k, JSON.stringify({a:a, t:now})); return a; })
      .catch(function(){ return false; });
  }
  /* first colour of this kind that is in stock, in the robe's preference order */
  function pickGift(kind, order){
    var opts = GIFT_KINDS[kind];
    return order.reduce(function(p, colour){
      return p.then(function(found){
        if(found) return found;
        var o = opts[colour];
        if(!o || ss('ssGiftFail' + o.v)) return null;
        return avail(o.h).then(function(a){ return a ? o.v : null; });
      });
    }, Promise.resolve(null));
  }
  var MAX_SETS = 3;
  /* 6 Oct 2026 (evening, Calum): ONE GIFT SET PER ROBE, capped at MAX_SETS. Each robe line gets its own
     beanie + headband in ITS colour (Pink + Sand → a pink pair and a sand pair); two pink robes → two pink
     pairs. Gift lines carry _gift:'robe' and _gift_for:<robe product id>. Beanies: ROBE.GIFT.BEANIE.3T is
     a per-robe BXGY (uses per order raised to 3). Headbands: a flat code per robe count — £20 / £40 / £60. */
  function robeUnits(items){ var n = 0; items.forEach(function(i){ if(CHANGING.indexOf(i.product_id) >= 0) n += i.quantity; }); return Math.min(n, MAX_SETS); }
  function clearGiftFlags(pid){
    KIND_NAMES.forEach(function(kind){ (pid ? [pid] : CHANGING).forEach(function(p){ ss('ssGiftSkip' + kind + p, null); ss('ssGiftAdded' + kind + p, null); }); });
  }
  /* returns a Promise that resolves true when it changed the cart (caller re-syncs) */
  function giftSets(items){
    var robes = [], byPid = {};
    items.forEach(function(i){
      if(CHANGING.indexOf(i.product_id) >= 0){
        if(!byPid[i.product_id]){ byPid[i.product_id] = { pid: i.product_id, qty: 0 }; robes.push(byPid[i.product_id]); }
        byPid[i.product_id].qty += i.quantity;
      }
    });
    /* our gift lines, with the robe each belongs to (a legacy tag without _gift_for belongs to the first robe) */
    var tagged = [];
    items.forEach(function(i){
      if(ALL_GIFT_VARS.indexOf(i.variant_id) >= 0 && i.properties && i.properties._gift){
        tagged.push({ key: i.key, variant: i.variant_id, qty: i.quantity, kind: kindOf(i.variant_id), pid: parseInt(i.properties._gift_for, 10) || (robes[0] ? robes[0].pid : 0) });
      }
    });
    if(!robes.length){
      /* no changing robe: take back EVERY tagged gift (storage-independent) and forget the flags */
      clearGiftFlags(null);
      if(!tagged.length) return Promise.resolve(false);
      return tagged.reduce(function(p, t){ return p.then(function(){ return post('/cart/change.js', {id: t.key, quantity: 0}); }); }, Promise.resolve()).then(function(){ return true; }).catch(function(){ return true; });
    }
    /* sets each robe is entitled to, in cart order, capped */
    var budget = MAX_SETS, want = {};
    robes.forEach(function(r){ var n = Math.min(r.qty, budget); budget -= n; want[r.pid] = n; });
    var have = {};
    tagged.forEach(function(t){ var k = t.pid + '|' + t.kind; have[k] = (have[k] || 0) + t.qty; });
    /* 1) gifts for a robe that left, or beyond its quota → cut back (ours to cut: we added them) */
    var cuts = [];
    tagged.forEach(function(t){
      var need = want[t.pid] || 0, k = t.pid + '|' + t.kind;
      if(have[k] > need){
        var cut = Math.min(t.qty, have[k] - need); have[k] -= cut;
        cuts.push({ key: t.key, qty: t.qty - cut });
        if(!need) clearGiftFlags(t.pid); else ss('ssGiftAdded' + t.kind + t.pid, String(have[k]));
      }
    });
    /* 2) missing gifts → add, unless the customer removed one we added (recorded count > what is there) */
    var adds = [];
    return robes.reduce(function(p, r){ return p.then(function(){
      var need = want[r.pid]; if(!need) return;
      return KIND_NAMES.reduce(function(p2, kind){ return p2.then(function(){
        var k = r.pid + '|' + kind, cur = have[k] || 0, addedKey = 'ssGiftAdded' + kind + r.pid;
        if(cur >= need){ ss(addedKey, String(cur)); return; }
        var prev = parseInt(ss(addedKey) || '0', 10);
        if(prev > cur) ss('ssGiftSkip' + kind + r.pid, '1');
        if(ss('ssGiftSkip' + kind + r.pid)) return;
        var order = GIFT_ORDER[r.pid] || ['black','white','sand','pink'];
        return pickGift(kind, order).then(function(v){
          if(!v) return;
          adds.push({ id: v, quantity: need - cur, properties: { _gift: 'robe', _gift_for: String(r.pid) } });
          ss(addedKey, String(need));
        });
      }); }, Promise.resolve());
    }); }, Promise.resolve()).then(function(){
      return cuts.reduce(function(p, c){ return p.then(function(){ return post('/cart/change.js', {id: c.key, quantity: c.qty}); }); }, Promise.resolve()).then(function(){ return cuts.length > 0; }).catch(function(){ return cuts.length > 0; });
    }).then(function(changed){
      if(!adds.length) return changed;
      return post('/cart/add.js', {items: adds}).then(function(r){
        if(!r.ok){ adds.forEach(function(a){ ss('ssGiftFail' + a.id, '1'); ss('ssGiftAdded' + kindOf(a.id) + a.properties._gift_for, null); }); return changed; } /* sold out between check and add → next colour next sync */
        return true;
      }).catch(function(){ return changed; });
    });
  }
  function post(url, body){
    return fetch(url, {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json'}, body:JSON.stringify(body)});
  }
  /* which of our codes a cart should carry */
  function wanted(items){
    var chg = 0, tow = 0, paidAcc = false, paidNonTow = false;
    /* which gift kinds have a tagged (auto-added) line — with one present, any OTHER beanie/headband line is a
       paid extra even when Shopify happens to book the free-ness on it (the money is per kind, not per line) */
    var tagged = {};
    items.forEach(function(i){ if(i.properties && i.properties._gift && ALL_GIFT_VARS.indexOf(i.variant_id) >= 0) tagged[kindOf(i.variant_id)] = true; });
    items.forEach(function(i){
      var pid = i.product_id;
      if(CHANGING.indexOf(pid) >= 0){ chg += i.quantity; return; }
      var isTow = TOWELLING.indexOf(pid) >= 0;
      if(isTow) tow += i.quantity;
      /* with a gift robe in the cart its gift lines are the gift code's job, not ROBE.BUNDLE's —
         otherwise the moment they land at full price they'd pull ROBE.BUNDLE in for one sync and out again */
      if(ALL_GIFT_VARS.indexOf(i.variant_id) >= 0){
        if(i.properties && i.properties._gift) return;
        if(i.final_line_price === 0 && !tagged[kindOf(i.variant_id)]) return; /* legacy untagged gift */
        paidAcc = true; if(!isTow) paidNonTow = true; return;
      }
      if(ACC_PIDS.indexOf(pid) >= 0 && i.final_line_price > 0){ paidAcc = true; if(!isTow) paidNonTow = true; }
    });
    /* 22 Sep 2026: no second-robe codes — a changing robe entitles accessories + towelling
       (ROBE.BUNDLE); a towelling robe entitles accessories only (TOWEL.BUNDLE). */
    var w = [];
    if(chg > 0){
      if(paidAcc) w.push(CODE_CHG);
      var sets = robeUnits(items); /* one set per robe, capped */
      w.push(CODE_GIFT_B); w.push(sets >= 3 ? CODE_GIFT_H3 : (sets === 2 ? CODE_GIFT_H2 : CODE_GIFT_H));
    } else if(tow > 0){
      if(paidNonTow) w.push(CODE_TOW);
    }
    return w;
  }
  function sync(){
    if(busy) return; busy = true;
    fetch('/cart.js', {credentials:'same-origin'}).then(function(r){ return r.json(); }).then(function(c){
      return giftSets(c.items || []).then(function(changed){
        if(!changed) return c;
        return fetch('/cart.js', {credentials:'same-origin'}).then(function(r){ return r.json(); }).then(function(c2){ c2.ssGiftsChanged = true; return c2; });
      });
    }).then(function(c){
      var items = c.items || [];
      var codes = c.discount_codes || [];
      var upper = codes.map(function(x){ return (x.code||'').toUpperCase(); });
      var mineNow = upper.filter(function(k){ return CODES.indexOf(k) >= 0; }).sort();
      var others = codes.map(function(x){ return x.code; }).filter(function(x){ return CODES.indexOf(x.toUpperCase()) < 0; });
      var want = wanted(items).sort();
      var same = mineNow.length === want.length && mineNow.every(function(k, idx){ return k === want[idx]; });
      if(same){ busy = false; if(c.ssGiftsChanged){ try{ document.dispatchEvent(new CustomEvent('cart:refresh', { detail: {} })); }catch(e){} } return; }
      post('/cart/update.js', {discount: others.concat(want).join(',')}).then(function(){
        busy = false;
        try{ document.dispatchEvent(new CustomEvent('cart:refresh', { detail: {} })); }catch(e){}
      }).catch(function(){ busy = false; });
    }).catch(function(){ busy = false; });
  }
  if(document.readyState !== 'loading') sync(); else document.addEventListener('DOMContentLoaded', sync);
  document.addEventListener('cart:refresh', function(){ setTimeout(sync, 600); });
  /* the theme's own add-to-cart never fires cart:refresh, so watch cart calls directly */
  if(window.fetch && !window.fetch.ssCartWatch){
    var origFetch = window.fetch;
    var t = null;
    window.fetch = function(input, init){
      var u = (typeof input === 'string') ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if(/\/cart\/(add|change|update|clear)/.test(u)){
        p.then(function(){ clearTimeout(t); t = setTimeout(sync, 800); }).catch(function(){});
      }
      return p;
    };
    window.fetch.ssCartWatch = true;
  }
})();

/* === Seashell: cart recommendations arrows advance a full pair === */
(function(){
  document.addEventListener('click', function(e){
    var t = e.target;
    if(!t || !t.closest) return;
    var btn = t.closest('#CartDrawer product-recommendations [data-next-button], #CartDrawer product-recommendations [data-prev-button]');
    if(!btn || !window.Flickity) return;
    var wrap = btn.closest('product-recommendations');
    var slider = wrap ? wrap.querySelector('.flickity-enabled') : null;
    var f = slider ? Flickity.data(slider) : null;
    if(!f) return;
    e.stopPropagation();
    e.preventDefault();
    var step = btn.hasAttribute('data-next-button') ? 2 : -2;
    var idx = f.selectedIndex + step;
    if(idx < 0) idx = 0;
    if(idx > f.cells.length - 1) idx = f.cells.length - 1;
    f.select(idx);
  }, true);
})();

/* === Seashell: auto-add free baseball cap — REMOVED 19 Aug 2026 ===
   The cap is no longer added to the cart automatically when a changing robe
   is added. The 'Summer Cap Promo' automatic discount was deactivated at the
   same time. 25 Aug 2026: the FREECAP code itself was retired too (the code
   is EXPIRED in Shopify) and its cart-drawer auto-add path was removed from
   the discount-error block above. The server-rendered [data-ss-cap-state]
   marker in sections/cart-drawer.liquid is left in place (inert). === */

/* === Seashell: recommended add-ons add straight to cart === */
(function(){
  document.addEventListener('click', function(e){
    var t = e.target;
    if(!t || !t.closest) return;
    var lbl = t.closest('label.product-bundle__info');
    if(!lbl) return;
    var inp = lbl.querySelector('input[name="bundles"][id^="Recommendations-"]');
    if(!inp) return;
    e.preventDefault();
    e.stopPropagation();
    if(inp.classList.contains('ss-added') || inp.dataset.ssBusy) return;
    inp.dataset.ssBusy = '1';
    fetch('/cart/add.js', {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json'}, body:JSON.stringify({id: parseInt(inp.value, 10), quantity: 1})})
      .then(function(r){
        if(!r.ok) throw 0;
        inp.checked = false;
        inp.classList.add('ss-added');
        try{ document.dispatchEvent(new CustomEvent('cart:refresh', { detail: {} })); }catch(err){}
        delete inp.dataset.ssBusy;
      })
      .catch(function(){ delete inp.dataset.ssBusy; });
  }, true);
})();

/* === Seashell: cart drawer express — ONE device wallet (31 Aug 2026) ===
   Shopify's cart accelerated-checkout component renders every enabled wallet
   (Shop Pay, PayPal, Apple Pay on iPhone/Safari, Google Pay on Android/Chrome)
   inside a closed shadow DOM with a fixed slot per wallet. Calum wants exactly one
   quick option next to Checkout: Apple Pay for Apple users, Google Pay for
   Android users, nothing otherwise. Hiding the others leaves empty slots, so this
   hides every wallet but the device one, clips the host to one row and slides the
   chosen button into that row. Re-runs whenever the drawer re-renders. Remove
   this block (and the .ss-express div in sections/cart-drawer.liquid) to revert. === */
(function(){
  var PICK = ['shopify-apple-pay-button', 'shopify-google-pay-button'];
  function run(){
    var wraps = document.querySelectorAll('cart-drawer .ss-express');
    for(var w = 0; w < wraps.length; w++){
      var wrap = wraps[w];
      var host = wrap.querySelector('shopify-accelerated-checkout-cart');
      if(!host){ wrap.style.display = 'none'; continue; }
      var kids = [].slice.call(host.children);
      if(!kids.length){ wrap.style.display = 'none'; continue; } /* not rendered yet — the observer calls again */
      var pick = null;
      for(var i = 0; i < PICK.length && !pick; i++){ pick = host.querySelector(PICK[i]); }
      if(!pick){ wrap.style.display = 'none'; continue; }
      kids.forEach(function(k){ if(k !== pick){ k.style.setProperty('display', 'none', 'important'); } });
      pick.style.setProperty('display', 'block', 'important');
      pick.style.setProperty('width', '100%', 'important');
      pick.style.transform = 'none';
      wrap.style.display = 'block';
      host.style.display = 'block';
      host.style.overflow = 'hidden';
      host.style.height = '50px';
      host.style.maxHeight = '50px';
      var hr = host.getBoundingClientRect(), pr = pick.getBoundingClientRect();
      var dx = pr.left - hr.left, dy = pr.top - hr.top;
      if(Math.abs(dx) > 1 || Math.abs(dy) > 1){ pick.style.transform = 'translate(' + (-dx) + 'px,' + (-dy) + 'px)'; }
    }
  }
  var t = null;
  function sched(){ clearTimeout(t); t = setTimeout(run, 80); }
  if(window.MutationObserver){
    new MutationObserver(sched).observe(document.documentElement, {childList: true, subtree: true});
  }
  document.addEventListener('cart:refresh', sched);
  window.addEventListener('resize', sched);
  window.addEventListener('load', sched);
  if(document.readyState !== 'loading') sched(); else document.addEventListener('DOMContentLoaded', sched);
})();

/* === Seashell: collection pages — robe-in-basket strip + live 25% prices (31 Aug 2026) ===
   On any collection page: a strip above the first Accessories/Clothing section that
   explains the offer (no robe yet) or confirms it (robe in basket), and — while a
   robe is in the basket — accessory/clothing cards show the 25% price with the
   original struck. Same rule as the cart auto-pilot (10 Sep 2026): any robe in the
   basket entitles the Bundle Accessories set. 22 Sep 2026: a towelling robe is 25% off
   only beside a CHANGING robe (ROBE.BUNDLE); with towelling-only in the basket the
   towelling cards stay full price. Changing-robe cards are never discounted. === */
(function(){
  if(!document.body || !document.body.classList.contains('template-collection')) return;
  var CHANGING  = [7921989517548,8161692123372,8659850297580,8659850166508,8249444204780];
  var TOWELLING = [7646192730348,8161713684716,8161714077932];
  var ENTITLED = ['seashell-towelling-robe','seashell-22l-drybag-backpack','towelling-robe-teal','merino-wool-beanie','22l-drybag-backpack-stone','towelling-robe-sand','seashell-fleece','changing-mat-copy','changing-mat','organic-cotton-t-shirt-long-sleeve-copy','seashell-baseball-cap','merino-wool-beanie-off-white','merino-wool-beanie-sand','headband-black','headband-pink','headband-white','headband','merino-wool-beanie-pink'];
  var TOWEL_H = ['seashell-towelling-robe','towelling-robe-teal','towelling-robe-sand'];
  /* 7 Oct 2026: restyled to match the robe perks tile (.ss-perks in featured-collection.liquid) */
  var css = '.ss-rs{display:flex;align-items:center;gap:10px;margin:16px 0 22px;padding:11px 14px;max-width:640px;background:rgb(var(--color-background));border:1px solid rgb(var(--color-foreground)/0.14);border-radius:12px;font-size:14px;line-height:1.3}'
          + '.ss-rs svg{flex:0 0 20px;width:20px;height:20px;color:#0F95CD}'
          + '.ss-rs b{font-weight:600}'
          + '.ss-rs__note{margin-left:auto;font-size:12px;opacity:.65;white-space:nowrap}'
          + '.ss-rs--on svg{color:#1a9d5a}'
          + '.ss-rs--on .ss-rs__note{opacity:1;font-weight:700;color:#1a9d5a;background:#e8f5ee;border-radius:999px;padding:3px 9px}'
          + '.ss-disc{color:#0F95CD;font-weight:700}.ss-was{opacity:.5;font-weight:400;margin-left:4px}'
          + '@media (max-width:389px){.ss-rs__note{display:none}}'
          + '@media (min-width:768px){.ss-rs{margin:20px 0 28px;padding:13px 16px;font-size:15px}}';
  function ensureCss(){ if(document.getElementById('ss-rs-css')) return; var st=document.createElement('style'); st.id='ss-rs-css'; st.textContent=css; document.head.appendChild(st); }
  function fmt(p){ return '£' + p.toFixed(2); }
  function parse(t){ var m=(t||'').replace(/,/g,'').match(/£\s*([\d.]+)/); return m ? parseFloat(m[1]) : null; }
  function strip(on){
    var secs = document.querySelectorAll('main [id^="shopify-section"]');
    var target = null;
    for(var i=0;i<secs.length;i++){ var h=secs[i].querySelector('h2'); if(h && /accessories|clothing/i.test(h.textContent||'')){ target=secs[i]; break; } }
    if(!target) return;
    var el = document.getElementById('ss-robe-strip');
    if(!el){
      /* sit directly under the section's heading + intro, above its product grid — not wedged against whatever section comes before */
      var h = target.querySelector('h2');
      var anchor = h;
      var nxt = h ? h.nextElementSibling : null;
      if(nxt && !nxt.querySelector('.product-card') && (nxt.textContent||'').trim().length < 400) anchor = nxt;
      el=document.createElement('div'); el.id='ss-robe-strip';
      if(anchor){ anchor.insertAdjacentElement('afterend', el); } else { target.parentNode.insertBefore(el, target); el.className='page-width'; }
    }
    var state = on ? 'on' : 'off';
    if(el.dataset.state === state) return;
    el.dataset.state = state;
    el.innerHTML = on
      ? '<div class="ss-rs ss-rs--on" role="note"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M8 12.5l2.8 2.8L16 10"/></svg><span><b>Robe in your basket</b> · 25% off every accessory</span><span class="ss-rs__note">Applied</span></div>'
      : '<div class="ss-rs" role="note"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12V4a1 1 0 0 1 1-1h8l9 9-9 9z"/><circle cx="7.5" cy="7.5" r="1.5"/></svg><span><b>25% off every accessory</b> with any robe</span><span class="ss-rs__note">applied automatically</span></div>';
  }
  function prices(want){
    var cards = document.querySelectorAll('.product-card');
    for(var i=0;i<cards.length;i++){
      var card = cards[i];
      var a = card.querySelector('a[href*="/products/"]'); if(!a) continue;
      var h = ((a.getAttribute('href')||'').split('/products/')[1]||'').split(/[?#]/)[0];
      var reg = card.querySelector('.price .price__regular'); if(!reg) continue;
      if(card.querySelector('.price .price__sale, .price compare-at-price, .price .price__compare')) continue; /* already on sale — leave it */
      var elig = !!want && ENTITLED.indexOf(h) >= 0 && (want === 'CHG' || TOWEL_H.indexOf(h) < 0);
      if(elig){
        if(reg.dataset.ssOrig) continue;
        var p = parse(reg.textContent); if(p == null) continue;
        reg.dataset.ssOrig = reg.textContent.trim();
        reg.innerHTML = '<span class="ss-disc">' + fmt(p*0.75) + '</span><s class="ss-was">' + reg.dataset.ssOrig + '</s>';
      } else if(reg.dataset.ssOrig){
        reg.textContent = reg.dataset.ssOrig; delete reg.dataset.ssOrig;
      }
    }
  }
  var busy=false;
  function run(){
    if(busy) return; busy=true;
    fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(c){
      busy=false;
      var items=c.items||[];
      var hasChg=items.some(function(i){return CHANGING.indexOf(i.product_id)>=0;});
      var hasTow=items.some(function(i){return TOWELLING.indexOf(i.product_id)>=0;});
      var want = hasChg ? 'CHG' : (hasTow ? 'TOW' : null);
      ensureCss(); strip(!!want); prices(want);
    }).catch(function(){ busy=false; });
  }
  var t=null; function sched(){ clearTimeout(t); t=setTimeout(run, 900); }
  if(document.readyState!=='loading') run(); else document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('cart:refresh', sched);
  if(window.fetch && !window.fetch.ssCollWatch){
    var of = window.fetch;
    window.fetch = function(input){ var u=(typeof input==='string')?input:(input&&input.url)||''; var p=of.apply(this, arguments); if(/\/cart\/(add|change|update|clear)/.test(u)){ p.then(sched).catch(function(){}); } return p; };
    window.fetch.ssCollWatch = true;
  }
})();

/* === Seashell: short discount labels in the cart drawer (31 Aug 2026) ===
   Shopify prints the full discount title on every line ("Pebble Pink — Free Beanie
   & Headband", "ROBE.BUNDLE"). The drawer shows a short human label instead; the
   full title still appears at checkout and on the order. === */
(function(){
  var MAP = [
    [/pebble pink/i, 'Free gift'],
    [/^PINK\.GIFT/i, 'Free gift'],
    [/midnight set/i, 'Free gift'],
    [/^MIDNIGHT\.GIFT/i, 'Free gift'],
    [/camo set/i, 'Free gift'],
    [/^CAMO\.GIFT/i, 'Free gift'],
    [/^ROBE\.GIFT/i, 'Free gift'],
    [/^ROBE\.BUNDLE$/i, 'Robe bundle −25%'],
    [/^TOWEL\.BUNDLE$/i, 'Robe bundle −25%'],
    [/^ROBE\.SECOND$/i, 'Second robe −25%'],
    [/^TOWEL\.SECOND$/i, 'Second robe −25%'],
    [/2FOR22/i, '2 pairs for £22'],
    [/buy 2 save £20/i, 'Buy 2, save £20'],
    [/^FREECAP$/i, 'Free cap'],
    [/second life/i, 'Second Life offer']
  ];
  function run(){
    var badges = document.querySelectorAll('cart-drawer .discounts__discount .badge');
    for(var i=0;i<badges.length;i++){
      var b = badges[i]; if(b.dataset.ssShort) continue;
      var t = (b.textContent || '').trim();
      for(var k=0;k<MAP.length;k++){ if(MAP[k][0].test(t)){ b.textContent = MAP[k][1]; b.title = t; break; } }
      b.dataset.ssShort = '1';
    }
    /* 6 Oct 2026: the totals block lists the applied codes — shorten them the same way, de-duplicated */
    var sc = document.querySelectorAll('cart-drawer .ss-saving-codes');
    for(var j=0;j<sc.length;j++){
      var el = sc[j]; if(el.dataset.ssShort) continue;
      var parts = (el.textContent||'').split(','), out = [];
      for(var q=0;q<parts.length;q++){
        var raw = parts[q].trim(), lab = raw;
        for(var m=0;m<MAP.length;m++){ if(MAP[m][0].test(raw)){ lab = MAP[m][1]; break; } }
        if(out.indexOf(lab) < 0) out.push(lab);
      }
      el.title = el.textContent; el.textContent = out.join(' · '); el.dataset.ssShort = '1';
    }
  }
  var t=null; function sched(){ clearTimeout(t); t=setTimeout(run, 60); }
  if(window.MutationObserver){ new MutationObserver(sched).observe(document.documentElement, {childList:true, subtree:true}); }
  if(document.readyState!=='loading') run(); else document.addEventListener('DOMContentLoaded', run);
})();

/* === Seashell: bundle page mirrors the cart (1 Sep 2026) ===========================
   /pages/build-your-bundle already knows about robes in the cart, but not accessories,
   and its footer bar only counted what was picked ON the page — so a visitor arriving
   with a robe + mat already in the cart saw "Robe in cart · £0". This block:
   - badges accessory cards that are in the cart ("In your cart"), like the robe cards;
   - folds the live cart into the footer bar: summary, total (struck full total) and
     saving are cart + page picks combined. The CTA still adds only the NEW picks.
   It never touches the builder's own state; it re-reads /cart.js and re-patches the
   bar after every repaint (MutationObserver) and every cart change. */
(function(){
  var root=document.getElementById('ssbb'); if(!root) return;
  var cart=null, vidToAcc={}, vidToRobe={};
  root.querySelectorAll('.card[data-variants]').forEach(function(c){
    try{ JSON.parse(c.dataset.variants).forEach(function(v){ (c.classList.contains('robe')?vidToRobe:vidToAcc)[v.id]=c; }); }catch(e){}
  });
  function money(p){ return '£'+(p.toFixed(2).replace(/\.00$/,'')); }
  function num(s){ var m=(s||'').replace(/,/g,'').match(/£\s*([\d.]+)/); return m?parseFloat(m[1]):0; }
  function summary(){
    var parts=[], acc=0;
    (cart.items||[]).forEach(function(it){
      var rc=vidToRobe[it.variant_id];
      if(rc){
        var t=rc.dataset.title||'';
        parts.push(/towelling/i.test(t) ? t.replace(/Organic Cotton Towelling Robe /i,'')+' towelling' : t.replace(/Changing Robe /i,'').replace(/ \(Previous Gen\)/i,'')+' robe');
      } else { acc+=it.quantity; }
    });
    if(acc) parts.push(acc+' accessor'+(acc===1?'y':'ies'));
    return parts.join(' + ');
  }
  function markAcc(){
    root.querySelectorAll('.card.acc .incart-b').forEach(function(b){ b.remove(); });
    root.querySelectorAll('.card.acc.incart').forEach(function(c){ c.classList.remove('incart'); });
    (cart.items||[]).forEach(function(it){
      var c=vidToAcc[it.variant_id]; if(!c||c.querySelector('.incart-b')) return;
      var b=document.createElement('span'); b.className='incart-b'; b.textContent='In your cart'; c.appendChild(b); c.classList.add('incart');
    });
  }
  function patchBar(){
    if(!cart) return;
    var count=document.getElementById('ssbb-count'), tot=document.getElementById('ssbb-total'), st=document.getElementById('ssbb-status');
    if(!count||!tot||!st) return;
    /* skip our own writes (the observer sees them too) */
    if(count.textContent===count.dataset.ssOut && tot.innerHTML===tot.dataset.ssOut && st.textContent===st.dataset.ssOut) return;
    if(!(cart.item_count>0)){ delete count.dataset.ssOut; delete tot.dataset.ssOut; delete st.dataset.ssOut; return; }
    var base=count.textContent.trim();
    var s=summary();
    var newCount = (/^(Robe in cart|No robe yet)$/.test(base) ? 'In your cart: '+s : base+' · plus '+s+' in cart');
    var pageTot=num((tot.textContent.match(/^\s*£[\d.,]+/)||[''])[0]);
    var sEl=tot.querySelector('s'); var pageFull=sEl?num(sEl.textContent):pageTot;
    var cTot=(cart.total_price||0)/100, cFull=(cart.original_total_price||cart.total_price||0)/100;
    var T=pageTot+cTot, F=pageFull+cFull;
    var newTot = F>T+0.004 ? money(T)+'<s>'+money(F)+'</s>' : money(T);
    var stBase=st.textContent.trim();
    var pageSave=/You save/.test(stBase)?num(stBase):0;
    var save=pageSave+(cart.total_discount||0)/100;
    var gift=(stBase.match(/\+ £40 (of free )?gifts/)||[''])[0];
    var newSt, newCls;
    if(save>0.004){ newSt='You save '+money(save)+(gift?' '+gift:''); newCls='sv'; }
    else { newSt=stBase; newCls=st.className; }
    count.textContent=newCount; count.dataset.ssOut=newCount;
    tot.innerHTML=newTot; tot.dataset.ssOut=newTot;
    st.textContent=newSt; st.className=newCls; st.dataset.ssOut=newSt;
  }
  var t=null;
  function load(){
    clearTimeout(t);
    t=setTimeout(function(){
      fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(c){
        cart=c; markAcc();
        /* a fresh cart read must re-patch even if the bar text is unchanged */
        var count=document.getElementById('ssbb-count'); if(count) delete count.dataset.ssOut;
        patchBar();
      }).catch(function(){});
    },250);
  }
  var bar=root.querySelector('.bar');
  if(bar && window.MutationObserver){ new MutationObserver(function(){ patchBar(); }).observe(bar,{childList:true,subtree:true,characterData:true}); }
  document.addEventListener('cart:refresh',function(){ setTimeout(load,600); });
  if(window.fetch && !window.__ssBbFetchWrapped){
    window.__ssBbFetchWrapped=true;
    var of=window.fetch;
    window.fetch=function(){ var a=arguments; var u=(typeof a[0]==='string')?a[0]:(a[0]&&a[0].url)||''; var p=of.apply(this,a); if(/\/cart\/(add|change|update|clear)/.test(u)){ p.then(function(){ setTimeout(load,700); },function(){}); } return p; };
  }
  window.addEventListener('pageshow',function(e){ if(e.persisted) load(); });
  load();
})();

/* === Seashell: one shared "cart changed" signal (1 Sep 2026) ==========================
   The theme's own add-to-cart never fires cart:refresh. Any script that needs to react to
   the cart changing (PDP add-ons block, collection strip, bundle page) can listen for
   'ss:cart-changed' instead of each patching window.fetch. Debounced 700 ms. */
(function(){
  if(!window.fetch || window.fetch.ssChangedWatch) return;
  var of=window.fetch, t=null;
  window.fetch=function(input){
    var u=(typeof input==='string')?input:(input&&input.url)||'';
    var p=of.apply(this, arguments);
    if(/\/cart\/(add|change|update|clear)/.test(u)){
      p.then(function(){ clearTimeout(t); t=setTimeout(function(){ try{ document.dispatchEvent(new CustomEvent('ss:cart-changed')); }catch(e){} }, 700); }, function(){});
    }
    return p;
  };
  window.fetch.ssChangedWatch=true;
})();

/* === Seashell: cart drawer recommendations — live 25% prices (7 Sep 2026) =============
   "Customers also bought" in the drawer was the last surface still showing full price
   while a robe sat in the basket — collection cards (31 Aug) and the PDP add-ons block
   already rewrite theirs. Same rule as the cart auto-pilot and the collection strip
   (22 Sep 2026): a changing robe entitles the whole Bundle Accessories set, towelling
   included; a towelling-only basket entitles accessories but not another towelling robe.
   DISPLAY ONLY — the money comes from the Robe Kit codes the auto-pilot applies
   (ROBE.BUNDLE / TOWEL.BUNDLE). Cards already
   showing a sale/compare-at price are left alone.
   The theme re-renders the drawer on every cart change and the recommendations load
   async, so a MutationObserver re-applies from a cached cart state rather than re-fetching
   /cart.js on every repaint. === */
(function(){
  var CHANGING  = [7921989517548,8161692123372,8659850297580,8659850166508,8249444204780];
  var TOWELLING = [7646192730348,8161713684716,8161714077932];
  var ENTITLED = ['seashell-towelling-robe','seashell-22l-drybag-backpack','towelling-robe-teal','merino-wool-beanie','22l-drybag-backpack-stone','towelling-robe-sand','seashell-fleece','changing-mat-copy','changing-mat','organic-cotton-t-shirt-long-sleeve-copy','seashell-baseball-cap','merino-wool-beanie-off-white','merino-wool-beanie-sand','headband-black','headband-pink','headband-white','headband','merino-wool-beanie-pink'];
  var TOWEL_H = ['seashell-towelling-robe','towelling-robe-teal','towelling-robe-sand'];
  var CSS = '.ss-disc{color:#0F95CD;font-weight:700}.ss-was{opacity:.5;font-weight:400;margin-left:4px}';
  var want = null, busy = false, tRef = null, tApp = null;

  function ensureCss(){
    if(document.getElementById('ss-cdrec-css')) return;
    var st = document.createElement('style'); st.id = 'ss-cdrec-css'; st.textContent = CSS;
    document.head.appendChild(st);
  }
  function fmt(p){ return '£' + p.toFixed(2); }
  function parse(txt){ var m = (txt||'').replace(/,/g,'').match(/£\s*([\d.]+)/); return m ? parseFloat(m[1]) : null; }

  function apply(){
    var cards = document.querySelectorAll('#CartDrawer product-recommendations .horizontal-product');
    for(var i=0;i<cards.length;i++){
      var card = cards[i];
      var a = card.querySelector('a[href*="/products/"]'); if(!a) continue;
      var h = ((a.getAttribute('href')||'').split('/products/')[1]||'').split(/[?#]/)[0];
      var reg = card.querySelector('.price .price__regular'); if(!reg) continue;
      if(card.querySelector('.price .price__sale, .price compare-at-price, .price .price__compare')) continue;
      var elig = !!want && ENTITLED.indexOf(h) >= 0 && (want === 'CHG' || TOWEL_H.indexOf(h) < 0);
      if(elig){
        if(reg.dataset.ssOrig) continue;
        var p = parse(reg.textContent); if(p == null) continue;
        reg.dataset.ssOrig = reg.textContent.trim();
        reg.innerHTML = '<span class="ss-disc">' + fmt(p*0.75) + '</span><s class="ss-was">' + reg.dataset.ssOrig + '</s>';
      } else if(reg.dataset.ssOrig){
        reg.textContent = reg.dataset.ssOrig; delete reg.dataset.ssOrig;
      }
    }
  }
  function refresh(){
    if(busy) return; busy = true;
    fetch('/cart.js',{credentials:'same-origin'}).then(function(r){ return r.json(); }).then(function(c){
      busy = false;
      var items = c.items || [];
      var hasChg = items.some(function(i){ return CHANGING.indexOf(i.product_id) >= 0; });
      var hasTow = items.some(function(i){ return TOWELLING.indexOf(i.product_id) >= 0; });
      want = hasChg ? 'CHG' : (hasTow ? 'TOW' : null);
      ensureCss(); apply();
    }).catch(function(){ busy = false; });
  }
  function schedRefresh(){ clearTimeout(tRef); tRef = setTimeout(refresh, 250); }
  function schedApply(){ clearTimeout(tApp); tApp = setTimeout(apply, 200); }

  function watch(){
    var d = document.getElementById('CartDrawer');
    if(!d || !window.MutationObserver) return false;
    var root = d.closest('[id^="shopify-section"]') || d;
    if(root.dataset.ssRecWatch) return true;
    root.dataset.ssRecWatch = '1';
    /* apply() only writes when something is actually wrong, so the observer settles
       after one extra no-op pass instead of looping */
    new MutationObserver(schedApply).observe(root, {childList:true, subtree:true});
    return true;
  }
  function start(){ ensureCss(); refresh(); if(!watch()) setTimeout(watch, 1500); }

  if(document.readyState !== 'loading') start(); else document.addEventListener('DOMContentLoaded', start);
  document.addEventListener('cart:refresh', schedRefresh);
  document.addEventListener('ss:cart-changed', schedRefresh);
})();

/* === Seashell: product pages — robe-in-basket 25% price on the main price + buy button (29 Sep 2026) ===
   Mirrors the collection-card rule above: with a CHANGING robe in the basket every Bundle
   Accessory shows 25% off; with only a TOWELLING robe, accessories do but other towelling
   robes don't. Socks are excluded (own pack pricing). Anything already on sale is left alone.
   Re-applies after variant changes (theme re-renders the price) and on any cart change. */
(function(){
  var m = location.pathname.match(/\/products\/([^\/?#]+)/); if(!m) return;
  var handle = decodeURIComponent(m[1]);
  var CHANGING  = [7921989517548,8161692123372,8659850297580,8659850166508,8249444204780];
  var TOWELLING = [7646192730348,8161713684716,8161714077932];
  var ENTITLED = ['seashell-towelling-robe','seashell-22l-drybag-backpack','towelling-robe-teal','merino-wool-beanie','22l-drybag-backpack-stone','towelling-robe-sand','seashell-fleece','changing-mat-copy','changing-mat','organic-cotton-t-shirt-long-sleeve-copy','seashell-baseball-cap','merino-wool-beanie-off-white','merino-wool-beanie-sand','headband-black','headband-pink','headband-white','headband','merino-wool-beanie-pink'];
  var TOWEL_H = ['seashell-towelling-robe','towelling-robe-teal','towelling-robe-sand'];
  if(ENTITLED.indexOf(handle) < 0) return;
  var isTowel = TOWEL_H.indexOf(handle) >= 0;
  var on = false, busy = false, pending = false;
  function parse(t){ var x=(t||'').replace(/[^\d.,]/g,'').replace(/,/g,''); var n=parseFloat(x); return isFinite(n)?n:null; }
  function fmt(n){ n=Math.round(n*100)/100; return '£'+(n%1===0?n.toFixed(0):n.toFixed(2)); }
  function css(){
    if(document.getElementById('ss-pdp-disc-css')) return;
    var s=document.createElement('style'); s.id='ss-pdp-disc-css';
    s.textContent='.ss-pd-now{font-weight:700}.ss-pd-was{opacity:.5;font-weight:400;margin-left:6px;text-decoration:line-through}'
            + 'product-buy-price .ss-pd-was{opacity:.7}';
    document.head.appendChild(s);
  }
  function targets(){
    var info=document.querySelector('product-info'); if(!info) return [];
    var out=[];
    info.querySelectorAll('.product__price .price').forEach(function(p){
      if(p.querySelector('.price__sale, compare-at-price, .price__compare, s:not(.ss-pd-was)')) return; /* already on sale */
      var r=p.querySelector('.price__regular'); if(r) out.push({el:r, main:true});
    });
    document.querySelectorAll('product-info product-buy-price, product-sticky-form product-buy-price, product-sticky-form .price__regular').forEach(function(e){ out.push({el:e, main:false}); });
    return out;
  }
  function apply(){
    targets().forEach(function(t){
      var el=t.el;
      if(on){
        if(el.dataset.ssPd==='1') return;
        var p=parse(el.textContent); if(p==null) return;
        el.dataset.ssPdOrig=el.innerHTML; el.dataset.ssPd='1';
        el.innerHTML='<span class="ss-pd-now">'+fmt(p*0.75)+'</span><span class="ss-pd-was">'+fmt(p)+'</span>';
      } else if(el.dataset.ssPd==='1'){
        el.innerHTML=el.dataset.ssPdOrig||el.innerHTML; delete el.dataset.ssPd; delete el.dataset.ssPdOrig;
      }
    });
    var n=document.getElementById('ss-pd-note'); if(n) n.remove();
  }
  function run(){
    if(busy){ pending=true; return; } busy=true;
    fetch('/cart.js',{credentials:'same-origin',cache:'no-store'}).then(function(r){return r.json();}).then(function(c){
      busy=false;
      var items=c.items||[];
      var hasChg=items.some(function(i){return CHANGING.indexOf(i.product_id)>=0;});
      var hasTow=items.some(function(i){return TOWELLING.indexOf(i.product_id)>=0;});
      on = hasChg || (hasTow && !isTowel);
      css(); apply();
      if(pending){ pending=false; run(); }
    }).catch(function(){ busy=false; if(pending){ pending=false; run(); } });
  }
  var t=null; function sched(){ clearTimeout(t); t=setTimeout(run, 250); }
  var mt=null;
  function watch(){
    var info=document.querySelector('product-info'); if(!info) return false;
    new MutationObserver(function(){ clearTimeout(mt); mt=setTimeout(apply, 60); }).observe(info,{childList:true,subtree:true,characterData:true});
    var sf=document.querySelector('product-sticky-form');
    if(sf) new MutationObserver(function(){ clearTimeout(mt); mt=setTimeout(apply, 60); }).observe(sf,{childList:true,subtree:true,characterData:true});
    return true;
  }
  function start(){ run(); if(!watch()) setTimeout(watch, 1200); }
  if(document.readyState!=='loading') start(); else document.addEventListener('DOMContentLoaded', start);
  document.addEventListener('cart:refresh', sched);
  document.addEventListener('ss:cart-changed', sched);
  if(window.fetch && !window.fetch.ssPdpWatch){
    var of=window.fetch;
    window.fetch=function(input){ var u=(typeof input==='string')?input:(input&&input.url)||''; var p=of.apply(this, arguments); if(/\/cart\/(add|change|update|clear)/.test(u)){ p.then(sched).catch(function(){}); } return p; };
    window.fetch.ssPdpWatch=true;
  }
})();

/* === Seashell: add-ons rail size pills + add button (cart drawer, 6–7 Oct 2026) ===
   Sized add-ons (towelling robe, socks) show their sizes on the card; one tap adds that
   variant. The theme's quick view can't be used here: it fetches ?view=modal, and the
   custom product templates have no modal view, so it opened an empty sheet. */
(function(){
  document.addEventListener('click', function(e){
    if(!e.target || !e.target.closest) return;
    /* 7 Oct 2026: size pills only choose; the round + adds the chosen size (M pre-selected in Liquid) */
    var pick = e.target.closest('[data-ss-addon-pick]');
    if(pick && !pick.disabled){
      e.preventDefault();
      var card = pick.closest('.ss-addon'); if(!card) return;
      card.querySelectorAll('[data-ss-addon-pick]').forEach(function(p){ var on = (p === pick); p.classList.toggle('is-on', on); p.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      var add = card.querySelector('[data-ss-addon-add]'); if(add) add.setAttribute('data-ss-addon-add', pick.getAttribute('data-ss-addon-pick'));
      return;
    }
    var b = e.target.closest('[data-ss-addon-add]');
    if(!b || b.disabled) return;
    e.preventDefault();
    var id = parseInt(b.getAttribute('data-ss-addon-add'), 10);
    if(!id) return;
    b.classList.add('is-busy'); b.disabled = true;
    fetch('/cart/add.js', {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json'}, body: JSON.stringify({items:[{id:id, quantity:1}]})})
      .then(function(r){ if(!r.ok) throw 0; try{ document.dispatchEvent(new CustomEvent('cart:refresh', {detail:{}})); }catch(err){} })
      .catch(function(){ b.classList.remove('is-busy'); b.disabled = false; });
  });
})();
